/**
 * Apollo Client 4 では query / mutation 結果の `data` 型が `T | undefined` になる。
 * 本アプリは `errorPolicy: 'none'`（Apollo Client 4 の既定）で運用しており、成功時は必ず
 * `data` が存在し、エラー時は stream 自体が error する。よって map 内で `data` が
 * 欠落しているのは想定外であり、`?.` 等で握り潰さず例外として顕在化させる。
 */
export function assertGraphqlData<T extends { data: unknown }>(
  result: T,
): asserts result is T & { data: NonNullable<T['data']> } {
  if (result.data == null) {
    throw new Error('GraphQL 操作が想定外にデータを返しませんでした')
  }
}
